import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@lognai/synapse-design-system-v2';

export interface DismissConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason?: string) => void;
  submitting?: boolean;
}

export const DismissConfirmDialog: React.FC<DismissConfirmDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  submitting,
}) => {
  const [reason, setReason] = useState('');

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Dismiss this insight?</AlertDialogTitle>
          <AlertDialogDescription>
            It will be hidden for your whole company for 30 days unless the condition recurs afterward.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="py-2">
          <label className="text-sm font-medium" htmlFor="dismiss-reason">
            Reason (optional)
          </label>
          <textarea
            id="dismiss-reason"
            className="mt-1 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
            rows={2}
            placeholder="Why are you dismissing this?"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            maxLength={500}
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={submitting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => onConfirm(reason.trim() || undefined)}
            disabled={submitting}
          >
            {submitting ? 'Dismissing…' : 'Dismiss for 30 days'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
